import { Button } from "@9amhealth/shared";
import { css } from "@emotion/css";
import { useBlocNext } from "@blac/react";
import styled from "@emotion/styled";
import { FC, useEffect } from "react";
import { SkipCoachingSessionModal } from "../SkipCoachingSessionModal/SkipCoachingSessionModal";
import Translate from "../Translate/Translate";
import AppointmentSchedulerCubit from "./AppointmentSchedulerCubit";

const Wrap = styled.div`
  margin: 2.5rem 0 0;

  button * {
    text-transform: none;
  }
`;

/* The `transparent` outline theme is already this design's pill — a see-through
   fill with a hairline border. `&&&&` outranks that theme's own
   `[data-theme][data-outline]` rule, which sits on this same element. */
const skipButtonStyle = css`
  &&&& {
    --btn-height: 2.75rem;
    border-color: var(--greys-charcoal, #212121);
  }
`;

const SkipVisitSection: FC<{ taskPath: string }> = ({ taskPath }) => {
  const [
    { isSkipConfirmationOpen },
    {
      openSkipConfirmation,
      closeSkipConfirmation,
      cancelSkipConfirmation,
      skipTask
    }
  ] = useBlocNext(AppointmentSchedulerCubit);

  useEffect(() => closeSkipConfirmation, []);

  const requestSkip = () => openSkipConfirmation(taskPath);
  const cancelSkip = () => cancelSkipConfirmation(taskPath);
  const confirmSkip = () => void skipTask(taskPath);

  return (
    <Wrap>
      <Button
        theme="transparent"
        outline
        grow
        hideArrow
        className={skipButtonStyle}
        onPress={requestSkip}
      >
        <Translate msg="skipCoachingSession.cta" />
      </Button>

      <SkipCoachingSessionModal
        isOpen={isSkipConfirmationOpen}
        onCancel={cancelSkip}
        onDismissed={closeSkipConfirmation}
        onConfirm={confirmSkip}
      />
    </Wrap>
  );
};

export default SkipVisitSection;
